import { Login } from 'presentation/app/modules/Authentication/pages/login';
import React from 'react';

import { makeRemoteAuthentication } from '../../usecases/Authentication/authentication-factory';

export const MakeLogin: React.FC = () => {
  return <Login authentication={makeRemoteAuthentication()} />;
};
